"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import ClockIcon from "~/components/icons/clock-icon-eon";
import FileIcon from "~/components/icons/file-icon-eon";
import Home from "~/components/icons/home-eon";
import { FormattedTitle } from "~/components/job-page/ad/formatted-title-eon";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function HeaderImageEonGridsolutions(t0) {
  const $ = _c(37);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.content.headerImage) {
    t1 = <div className="relative aspect-video lg:aspect-auto"><CustomImage className="h-full max-h-[700px] object-cover object-left" height={1070} sizes="(max-width: 1024px) 100vw, 60vw" src={job.content.headerImage} width={2000} /></div>;
    $[0] = job.content.headerImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== job.data.title) {
    t2 = <div className="text-lg xl:text-xl"><h1 className="mb-6 font-headline text-3xl xl:text-4xl" data-source="job"><FormattedTitle input={job.data.title} /></h1></div>;
    $[2] = job.data.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Home className="mt-1 mr-3 size-[34px]" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== job.data.company) {
    t4 = <li className="flex w-full items-start">{t3}<span data-source="job">{job.data.company}</span></li>;
    $[5] = job.data.company;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FileIcon className="mt-1 mr-3 size-[34px]" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== job.data.contract || $[9] !== job.data.remote) {
    t6 = <li className="flex w-full items-start">{t5}<span data-source="job">{job.data.remote}, {job.data.contract}</span></li>;
    $[8] = job.data.contract;
    $[9] = job.data.remote;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ClockIcon className="mt-1 mr-3 size-[34px]" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== job.data.employmentType || $[13] !== t) {
    t8 = combineEmploymentTypes(job.data.employmentType, t);
    $[12] = job.data.employmentType;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <li className="flex w-full items-start">{t7}<span data-source="job">{t8}</span></li>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t9) {
    t10 = <ul className="flex flex-col text-lg lg:mt-8 xl:text-xl">{t4}{t6}{t9}</ul>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== job) {
    t11 = job.data.applicationUrl.length > 2 && <ApplyButton job={job} variant="econ" />;
    $[21] = job;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== job) {
    t12 = job.data.applicationUrlDirect && <ApplyButton direct={true} job={job} variant="econ" />;
    $[23] = job;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div className="flex flex-col gap-4 md:flex-row print:hidden">{t11}{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t13) {
    t14 = <div className="space-y-6">{t10}{t13}</div>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t2) {
    t15 = <div className="h-full px-6 py-10 lg:max-w-[680px] lg:justify-self-start lg:px-10"><div className="mb-4 flex h-full flex-col justify-between xl:justify-end xl:gap-10">{t2}{t14}</div></div>;
    $[31] = t14;
    $[32] = t2;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t1 || $[35] !== t15) {
    t16 = <section className="w-full bg-primary text-white lg:flex lg:justify-center print:hidden"><div className="grid w-full auto-cols-fr lg:grid-flow-col xl:auto-cols-[3fr_2fr]">{t1}{t15}</div></section>;
    $[34] = t1;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
}